import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://mr-api.kuldeepkumawat.workers.dev/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        alert('Success! Your message has been sent. I will get back to you soon.');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        throw new Error(result.error || 'Submission failed');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error: Unable to send message. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-wrapper" id="contact">
      <div className="contact-container">
        <div className="section-header text-center" data-aos="fade-up">
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Have a project in mind? Let's work together to create something amazing!
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info-cards">
            <div className="contact-info-card" data-aos="fade-up">
              <div className="contact-icon">
                <i className="ph ph-phone"></i>
              </div>
              <h3>Phone</h3>
              <p>+91 9993679788</p>
              <a href="tel:+919993679788">Call Now</a>
            </div>

            <div className="contact-info-card" data-aos="fade-up" data-aos-delay="100">
              <div className="contact-icon">
                <i className="ph ph-envelope"></i>
              </div>
              <h3>Email</h3>
              <p>kumawatkuldeep950@gmail.com</p>
              <a href="mailto:kumawatkuldeep950@gmail.com">Send Email</a>
            </div>

            <div className="contact-info-card" data-aos="fade-up" data-aos-delay="200">
              <div className="contact-icon">
                <i className="ph ph-map-pin"></i>
              </div>
              <h3>Location</h3>
              <p>Indore, Madhya Pradesh</p>
              <a href="https://maps.google.com/?q=Indore,+Madhya+Pradesh" target="_blank" rel="noopener noreferrer">View on Map</a>
            </div>
          </div>

          <div className="contact-form-wrapper" data-aos="fade-up">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    required
                    disabled={isSubmitting}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Your Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                    disabled={isSubmitting}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Enter subject"
                  required
                  disabled={isSubmitting}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter your message"
                  rows="6"
                  required
                  disabled={isSubmitting}
                ></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                <span className="contact-btn-submit">
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                  {!isSubmitting && <i className="ph ph-paper-plane-tilt"></i>}
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>

      <footer className="portfolio-footer">
        <div className="footer-content">
          <p>&copy; 2025 Mr Kuldeep. All rights reserved.</p>
          {/* <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="ph ph-facebook-logo"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="ph ph-twitter-logo"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="ph ph-instagram-logo"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="ph ph-linkedin-logo"></i>
            </a>
          </div> */}
        </div>
      </footer>
    </section>
  );
};

export default Contact;